import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./app/redux/store";
import { TokenProvider } from "@/app/services/context/TokenContext";
import { CountryProvider } from "./app/services/context/CountryContext";
import { AccountsProvider } from "./app/services/context/AccountsContext";
import { PaymentProvider } from "./app/services/context/PaymentContext";
import { OnboardingProvider } from "./app/services/context/OnboardingContext";
import { UserDetailsProvider } from "./app/services/context/UserDetailsContext";
import { QueryProvider } from "@/app/provider/QueryProvider";
import OAuthHandler from "./app/provider/OAuthHandler";
import { loadEnvConfig } from "./app/apiConfig/urlConfig/envConfig";
import "dirham-symbol/dist/index.css";
import "@progress/kendo-theme-default/dist/all.css";
import "./index.css";
import { AdminProvider } from "./app/services/context/AdminContext";
import { NotificationProvider } from "./app/services/context/NotificationContext";

// ---------------- ROOT ----------------
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// ---------------- APP RENDER ----------------
const renderApp = () => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <TokenProvider>
            <UserDetailsProvider>
              <NotificationProvider>
                <OAuthHandler>
                  <CountryProvider>
                    <AccountsProvider>
                      <PaymentProvider>
                        <OnboardingProvider>
                          <QueryProvider>
                            <AdminProvider>
                              <App />
                            </AdminProvider>
                          </QueryProvider>
                        </OnboardingProvider>
                      </PaymentProvider>
                    </AccountsProvider>
                  </CountryProvider>
                </OAuthHandler>
              </NotificationProvider>
            </UserDetailsProvider>
          </TokenProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
  );
};

// ---------------- BOOTSTRAP ----------------
const bootstrap = async () => {
  try {
    await loadEnvConfig();
    renderApp();
  } catch (err) {
    root.render(
      <React.StrictMode>
        <div>
          Application failed to start. Please refresh or contact support.
        </div>
      </React.StrictMode>,
    );
  }
};

bootstrap();
